/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 10:22:39
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-21 15:28:43
 */
/**
 * Range Picker Template
 * @param configs ...
 * @returns string
 */
export default (configs: any): string => {
  let template = '';
  template += `
  <div class="gf-range-picker">
    <div class="gf-range-picker-slider">
      <p></p>
    </div>
    <div class="gf-range-picker-text">
      <input type="number" class="gf_remove-spin-button" value="${configs.value}"/>
      <span>${configs.valueType}</span>
    </div>
  </div>
  `;
  return template;
};
